__turbopack_context__.v({
  "big": "heading-module__CdsocG__big",
  "center": "heading-module__CdsocG__center",
  "heading": "heading-module__CdsocG__heading",
  "medium": "heading-module__CdsocG__medium",
  "small": "heading-module__CdsocG__small",
});
